/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { TextInput, Loading, FormGroup, Button, TextArea, TextInputSkeleton, DatePickerSkeleton } from "carbon-components-react";
import "../../../scss/custom.scss";
import Save16 from "@carbon/icons-react/lib/save/16";
import { CheckmarkOutline16, Information16 } from "@carbon/icons-react/lib/";
import { showNotification } from "../../../helpers/notification/BaseNotification";
import { getError, getSuccess, entitiesLabels, apioperation, DateFormat } from "../../../helpers/Constants";
import { api } from "../../../helpers/api/api";
import { IsEditable, CanExecuteAction } from "../../../helpers/authorization/Policies";
import { AppContext } from "../../../helpers/context/AppContext";
import PageBreadCrumb from "../../../helpers/PageBreadCrumb";
import { switchDateFormat } from "../../../helpers/jsonschemaform/customwidget/utils";
import { WFActionModal } from "../../common/WFActionModal";
import SimpleReactValidator from "simple-react-validator";
import { HistoryTable } from "../../../helpers/HistoryTable";
import InspectionRepository from "../../../helpers/api/InspectionRepository";
import DateTimePicker from "../../../helpers/DateTimePicker";
import { v4 as uuid } from "uuid";
import AttachmentTable from "../../common/AttachmentTable";

export default class InspectionCARDetail extends Component {
	baseUrl;

	constructor(props) {
		super(props);
		const idInspectionEdit = props ? props.match.params.id : "";
		const idCar = props ? props.match.params.idCar : "";
		const idAnswer = props ? props.match.params.idAnswer : "";
		this.validationsCar = new SimpleReactValidator();
		this.state = {
			isSubmitted: false,
			idInspectionEdit,
			idCar,
			idAnswer,
			isLoading: true,
			model: null,

			// /Status Action
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			// /Status Action
			isHistoryModalOpen: false,
		};
		this.baseUrl = `/inspection/${this.state.idInspectionEdit}/answer/${this.state.idAnswer}/car/${this.state.idCar}`;

		this.onCauseofInefficiencyChange = this.onCauseofInefficiencyChange.bind(this);
		this.onCorrectiveActionChange = this.onCorrectiveActionChange.bind(this);
		this.onImmediateTreatmentChange = this.onImmediateTreatmentChange.bind(this);
	}

	componentDidMount() {
		this.getCAR();
	}

	getCAR = () => {
		this.setState({
			isLoading: true,
		});

		api.getAll(this.baseUrl)
			.then((response) => {
				const { data } = response;
				if (data) {
					this.setState({
						model: data,
					});
				} else {
					showNotification.error(`${entitiesLabels.ERROR}`, "CAR not found");
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.GET));
				this.props.history.push(this.baseUrl);
			})
			.finally(() => {
				this.setState({
					isLoading: false,
				});
			});
	};

	updateCar = async () => {
		if (this.validationsCar.allValid()) {
			try {
				this.setState({ isSubmitted: true });
				await api.put(this.baseUrl, this.state.model);
				InspectionRepository.updateCachedCarList(this.state.model);
				showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.PUT));
			} catch (error) {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.CAR, apioperation.PUT));
			} finally {
				this.setState({ isSubmitted: false });
			}
		} else {
			this.validationsCar.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, ` ${entitiesLabels.INSPECTION_REPORT} required fields are missing  `);

			this.forceUpdate();
		}
	};

	showButtonHistory = () => (
		<Button className="action-button-modal" kind="secondary" renderIcon={Information16} onClick={() => this.openModalHistory()}>
			History
		</Button>
	);

	openModalHistory = () => {
		this.setState({ isHistoryModalOpen: true });
	};

	closeModalHistory = () => {
		this.setState({ isHistoryModalOpen: false });
	};

	showLoading() {
		const show = this.state.isLoading || this.state.isSubmitted;
		const descr = this.state.isSubmitted ? "Saving..." : "Loading data...";
		return show && <Loading active withOverlay description={descr} />;
		// return (<InlineLoading className="bx--loading-overlay" {...props} />)
	}

	onImmediateTreatmentChange(event) {
		const { value } = event.currentTarget;
		this.setState({
			model: {
				...this.state.model,
				immediateTreatment: value,
			},
		});
	}

	onCauseofInefficiencyChange(event) {
		const { value } = event.currentTarget;
		this.setState({
			model: {
				...this.state.model,
				causeOfInefficiency: value,
			},
		});
	}

	onCorrectiveActionChange(event) {
		const { value } = event.currentTarget;
		this.setState({
			model: {
				...this.state.model,
				correctiveAction: value,
			},
		});
	}

	IsRowSelectable() {
		const row = this.state.model;
		if (row == null) return false;
		return true;
	}

	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover,
			selectedData: selectedRows,
			approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired,
		});
	}

	getStatusActions = (user) => {
		if (!this.IsRowSelectable()) return null;

		const canEditResource = this.state.model && {
			idCompiler: this.state.model.inspectionReport.idCompiler,
			email: this.state.model.owner != null ? this.state.model.owner.email : this.state.model.ownerSaipem != null ? this.state.model.ownerSaipem.email : "",
		};

		const { idStatus } = this.state.model;
		return (
			<> 
				{CanExecuteAction("Inspection", "CARSimplified", user, idStatus, "Close", canEditResource) ? (
					<Button
						renderIcon={CheckmarkOutline16}
						onClick={() => {
							this.updateCar();
							this.batchActionClick("Close", "Close", null, false, true, null);
						}}
					>
						Close CAR
					</Button>
				) : null}
				{/* RITM1230561*/}
				{(CanExecuteAction("Inspection", "CARSimplified", user, idStatus, "Open", canEditResource)
				|| ((this.state.model.inspectionReport.idCompiler == user.id ||
				canEditResource.email == user.email) && this.state.model.inspectionReport?.idStatus == 1 && idStatus == 4) ) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Open", "Open", null, false, true, null)}>
						Open CAR
					</Button>
				) : null}
			</>
		);
	};

	// WF
	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};

	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};

	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};

	handleConfirmApprovalModal = () => {
		const apiEndpoint = this.state.approvalEndpoint;

		const data = {
			ids: [this.state.idCar],
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};
		if (!this.state.model.correctiveAction && this.state.model.idStatus == 1) {
			this.setState({
				isApprovalModalOpen: false,
			});
			return showNotification.warning(`${entitiesLabels.WARNING}`, `Corrective Action required field is missing`);
		}

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put(`/inspection/${this.state.idInspectionEdit}/car/${apiEndpoint}`, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isLoading: true,
						// model: null
					});
					this.getCAR();
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};

	updateActualCompletitionDate = (_, completationDate) => this.setState({model: {...this.state.model, actualDateCompletition: completationDate}})

	clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

	onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
	const attachment = { ...this.state.attachment };

	attachment.id = uuid();
	attachment.fileIdentifier = fileIdentifier.blobName;
	attachment.name = fileName;
	attachment.contentType = fileType;
	attachment.size = size;
	// attachment.filePath = file.localPath;

	this.setState({
		attachment: this.clearAttachment(),
	});

	try {
		if (attachment == null) return;
		// insert
		const oldattachment = this.state.model.attachment || [];

		const newItem = {
		id: uuid(), // guid

		idAttachment: attachment.id, // guid
		attachment,
		};

		const newattachment = oldattachment.concat([newItem]);
		this.setState({model: {...this.state.model, attachment: newattachment}})
	} catch (error) {
		showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.GET));
	}
	};

	onRemoveFile = (id) => {
	if (!id) return;
	const statusCopy = { ...this.state.model };
	statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
	this.setState({model: statusCopy});
	};


	render() {
		const canEditResource = this.state.model && {
			idCompiler: this.state.model.inspectionReport.idCompiler,
			idDataApprover: this.state.model.inspectionReport.idDataApprover,
			idDivisionManager: this.state.model.inspectionReport.idDivisionManager,
			email: this.state.model.owner != null ? this.state.model.owner.email : this.state.model.ownerSaipem != null ? this.state.model.ownerSaipem.email : "",
		};
		const validationCar = {
			correctiveAction: this.validationsCar.message("correctiveAction", this.state.model?.correctiveAction, "required"),
		};
		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<PageBreadCrumb
							linkTo={`/inspection/${this.state.idInspectionEdit}/car/`}
							linkText="CAR List"
							titleLeft={`Inspection Id: ${(this.state.model && this.state.model.inspection.inspectionCode) || ""} - CAR Detail`}
							titleCenter={this.state.model && `ID: ${this.state.model.inspectionCARCode || ""}`}
							titleRight={this.state.model && this.state.model.status ? this.state.model.status.cARSimplifiedName : null}
							batchActions={this.getStatusActions(user, canEditResource)}
							showButtonHistory={this.showButtonHistory()}
						/>
						<div className="mainContainer">
							{this.showLoading()}
							<WFActionModal
								show={this.state.isApprovalModalOpen}
								title={`${this.state.approvalModalAction} Inspection CAR`}
								action={this.state.approvalModalAction}
								withApprover={this.state.withApprover}
								approver={this.state.approver}
								approverRole={this.state.approverRole}
								approverOptions={this.state.approvers}
								isLoadingOperation={this.state.isLoadingWFOperation}
								onApproverSelect={this.handleApproverSelect}
								isLoadingOptions={this.state.isLoadingApproverOptions}
								onCancel={this.handleCloseApprovalModal}
								onConfirm={this.handleConfirmApprovalModal}
								onApprovalNotesChange={this.handleApprovalNotesChange}
								approvalNotes={this.state.approvalNotes}
								approvalNotesRequired={this.state.approvalNotesRequired}
								validationMessages={this.state.approvalValidationMessages}
							/>
							{/* RITM0946005 - Anonimizzazione Modulo Inspection */}
							<HistoryTable entityId={this.state.idCar} isOpenModal={this.state.isHistoryModalOpen} onClose={() => this.closeModalHistory()} masked={this.state.model?.inspection.maskedValue} /> 
							<div className="bx--row">
								<div className="bx--col-lg-12 bx--col-md-12">
									{this.state.model && (
										<div className="bx--row">
											<div className="bx--col-md-4 bx--col-lg-6">
												<FormGroup legendText="Requirement">
													<TextInput
														id="Requirement"
														type="text"
														labelText=""
														className="bx--text-input disable-text"
														defaultValue={
															this.state.model.inspectionReport?.checkList?.answers[0]?.question?.name
																? this.state.model.inspectionReport?.checkList?.answers[0]?.question?.name
																: this.state.model.inspectionReport?.checkList?.answers[0]?.requirement?.name
																? this.state.model.inspectionReport?.checkList?.answers[0]?.requirement?.name
																: ""
														}
														disabled
													/>
												</FormGroup>
											</div>
											<div className="bx--col-md-4 bx--col-lg-6">
												<FormGroup legendText="CAR Owner">
													<TextInput
														id="txt-name"
														type="text"
														labelText=""
														className="bx--text-input disable-text"
														defaultValue={
															this.state.model.owner
																? (this.state.model.inspection.maskedValue ? ((`${this.state.model.owner.name} ${this.state.model.owner.surname}`) != null ? this.state.model.owner.maskedValue : `${this.state.model.owner.name} ${this.state.model.owner.surname}`) :`${this.state.model.owner.name} ${this.state.model.owner.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
																: this.state.model.ownerSaipem
																? (this.state.model.inspection.maskedValue ? ((`${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`) != null ? this.state.model.ownerSaipem.fullNameMasked : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`) : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
																: ""
														}
														disabled
													/>
												</FormGroup>
											</div>
											<div className="bx--col-md-4 bx--col-lg-6">
												<FormGroup legendText="CAR Owner Email">
													<TextInput
														id="txt-email"
														type="text"
														labelText=""
														className="bx--text-input disable-text"
														defaultValue={
															this.state.model.owner
																? (this.state.model.inspection.maskedValue ? (this.state.model.owner.email != null ? this.state.model.owner.emailMasked : this.state.model.owner.email) : this.state.model.owner.email) //RITM0946005 - Anonimizzazione Modulo Inspection
																: this.state.model.ownerSaipem
																? (this.state.model.inspection.maskedValue ? (this.state.model.ownerSaipem.email != null ? this.state.model.ownerSaipem.ownerSaipem : this.state.model.ownerSaipem.email) : this.state.model.ownerSaipem.email) //RITM0946005 - Anonimizzazione Modulo Inspection
																: ""
														}
														disabled
													/>
												</FormGroup>
											</div>
											<div className="bx--col-md-4 bx--col-lg-6">
												<FormGroup legendText="Due Date">
													<TextInput
														id="dueDate1"
														type="text"
														labelText=""
														className="bx--text-input disable-text"
														defaultValue={switchDateFormat(this.state.model.dueDate, "date")}
														disabled
													/>
												</FormGroup>
											</div>
											<div className="bx--col-md-4 bx--col-lg-6">
												<FormGroup legendText="Status">
													<TextInput
														id="status"
														type="text"
														labelText=""
														className="bx--text-input disable-text"
														defaultValue={this.state.model.status && this.state.model.status.carSimplifiedName}
														disabled
													/>
												</FormGroup>
											</div>

											<div className="bx--col-md-6 bx--col-lg-6">
												<FormGroup legendText="Actual date of completion of CA">
													{!this.state.model ? (
													<TextInputSkeleton hideLabel />
													) : (
													<div className="bx--col-md-6 bx--col-lg-6 pl-0">
													{!this.state.model ? (
														<DatePickerSkeleton />
													) : (
														<DateTimePicker
														value={this.state.model?.actualDateCompletition}
														type="date"
														disableFutureDate
														placeholder={DateFormat}
														name="actualDateCompletition"
														alt="model"
														id="actualDateCompletition"
														onChange={this.updateActualCompletitionDate}
														disabled={!IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "ActualDateCompletition", canEditResource)}
														/>
													)}
													</div>
													)}
												</FormGroup>
											</div>

											<div className="bx--col-lg-12 bx--col-md-12">
												<FormGroup legendText="Details Of Inefficiency">
													<TextArea
														maxLength={5000}
														labelText=""
														id="inputDetailOfInefficiency"
														name="inputdetailsofinefficiency"
														cols={250}
														disabled
														invalid={false}
														invalidText="required"
														light
														placeholder=""
														rows={5}
														defaultValue={this.state.model.detailsOfInefficiency || ""}
													/>
												</FormGroup>
											</div>
											<div className="bx--col-lg-12 bx--col-md-12">
												<FormGroup legendText="Immediate Treatment (The mention of names and surnames must be done only if strictly necessary)">
													<TextArea
														maxLength={5000}
														labelText=""
														id="inputimmediateTreatment"
														name="inputimmediateTreatment"
														cols={250}
														disabled={!IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "ImmediateTreatment", canEditResource)}
														invalid={false}
														invalidText="required"
														light
														placeholder=""
														rows={5}
														value={this.state.model.immediateTreatment || ""}
														onChange={this.onImmediateTreatmentChange}
													/>
												</FormGroup>
											</div>
											<div className="bx--col-lg-12 bx--col-md-12" style={{ display: "none" }}>
												<FormGroup legendText="Cause of Inefficiency">
													<TextArea
														maxLength={5000}
														labelText=""
														id="inputCauseOfInefficiency"
														name="inputCauseOfInefficiency"
														cols={250}
														disabled={!IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "CauseOfInefficiency", canEditResource)}
														invalid={false}
														invalidText="required"
														light
														placeholder=""
														rows={5}
														value={this.state.model.causeOfInefficiency || ""}
														onChange={this.onCauseofInefficiencyChange}
													/>
												</FormGroup>
											</div>
											<div className="bx--col-lg-12 bx--col-md-12">
												<FormGroup legendText="Corrective Action*  (The mention of names and surnames must be done only if strictly necessary)">
													<TextArea
														maxLength={5000}
														labelText=""
														id="inputCorrectiveAction"
														name="inputCorrectiveAction"
														cols={250}
														disabled={!IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "CorrectiveAction", canEditResource)}
														invalid={validationCar.correctiveAction != null}
														invalidText=""
														light
														placeholder=""
														rows={5}
														value={this.state.model.correctiveAction || ""}
														onChange={this.onCorrectiveActionChange}
													/>
													{validationCar.correctiveAction}
												</FormGroup>
											</div>
											
											<AttachmentTable
												storagePath="inspection"
												model={this.state.model}
												items={this.state.model?.attachment}
												apiDownloadUrl={`/inspection/${this.state.idInspectionEdit}/answer/${this.state.idAnswer}/car/${this.state.idCar}/attachment/`}
												onUploadFIle={this.onUploadFiles}
												onDeleteFile={this.onRemoveFile}
												isDisabled={!IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "Attachments", canEditResource)}
											/>

											{IsEditable("Inspection", "CARSimplified", user, this.state.model ? this.state.model.idStatus : null, "CorrectiveAction", canEditResource) && (
												<div className="bx--col-lg-12 bx--col-md-12 main-information-button">
													<Button size="default" renderIcon={Save16} kind="primary" onClick={this.updateCar} disabled={this.state.isSubmitted || this.state.editingDisabled}>
														Save
													</Button>
												</div>
											)}
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
